import { call, put, takeLatest } from 'redux-saga/effects';
import { userService } from './user.service';
import { GET_USERS, GET_USERS_SUCCESS, CREATE_USER, CREATE_USER_SUCCESS, EDIT_USER, EDIT_USER_SUCCESS } from './user.types';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

function* getUsersSaga({ type }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(userService.getUsers);
    yield put({ type: GET_USERS_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* createUserSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(userService.createUser, payload);
    yield put({ type: CREATE_USER_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

function* editUserSaga({ type, payload }) {
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnErrorsActions.removeError(type));
  try {
    const res = yield call(userService.editUser, payload.id, payload.data);
    yield put({ type: EDIT_USER_SUCCESS, payload: res.data });
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
  } catch (err) {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
    yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
  }
}

export function* watchUsers() {
  yield takeLatest(GET_USERS, getUsersSaga);
  yield takeLatest(CREATE_USER, createUserSaga);
  yield takeLatest(EDIT_USER, editUserSaga);
}
